<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <table class="table table-condensed table-striped table-hover">
          <thead>
            <tr>
              <th colspan="2">Rubricas disponíveis:</th>
            </tr>
          </thead>
          <thead>
            <tr>
              <th>Rubrica</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rubrica, index) in rubricas">
              <td>{{ rubrica.descricao }}</td>
              <td>
                <a href="#" class="text-success" @click.prevent="add(rubrica)">
                  <i class="fa fa-plus"></i>
                </a>
              </td>
            </tr>
            <tr v-if="!rubricas.length">
              <td colspan="2" class="text-warning">Todas as rubricas foram adicionadas.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-sm-6">
        <table class="table table-condensed table-striped table-hover" id="table-rubricas-add">
          <thead>
            <tr>
              <th colspan="3">Rubricas adicionadas:</th>
            </tr>
          </thead>
          <thead>
            <tr>
              <th>Rubrica</th>
              <th>Nr. Conta</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rubrica, index) in empresaRubricas" v-show="rubrica.status !== 'DELETE'">
              <td>{{ rubricasDescriptions[rubrica.rubrica] }}</td>
              <td>
                <!-- <input type="number" class="form-control input-sm input-rubrica" v-model="rubrica.conta"> -->
                <input-editable
                  :value="rubrica.conta"
                  @on-save="vl => onInputChange(vl, rubrica)"
                  type="text"
                  v-if="rubrica.status === 'INSERT'"
                />
                <span v-else=""
                  ><strong>{{ rubrica.conta }}</strong></span
                >
              </td>
              <td>
                <a href="#" class="text-danger" @click.prevent="remove(rubrica, index)">
                  <i class="fa fa-trash-o"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import InputEditable from '../../components/Inputs/InputEditable.vue'
import EmpresaService from '../../services/EmpresaService'

export default {
  name: 'empresa-rubricas',
  props: {
    value: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      empresaRubricas: [],
      rubricasDisponiveis: [
        { rubrica: 'horasNormais', descricao: 'Horas Normais' },
        { rubrica: 'horasExtras50', descricao: 'Horas Extras 50%' },
        { rubrica: 'horasExtras75', descricao: 'Horas Extras 75%' },
        { rubrica: 'horasExtras100', descricao: 'Horas Extras 100%' },
        { rubrica: 'horasFaltas', descricao: 'Horas Faltas' },
        { rubrica: 'adicionalNoturnoAuto', descricao: 'Adic. Noturno Automático' },
        { rubrica: 'adicionalNoturnoInfor', descricao: 'Adic. Noturno Informado' }
      ]
    }
  },
  mounted() {
    this.empresaRubricas = this.value.rubricas
    this.getRubricas()
  },
  methods: {
    remove(rubrica, idx) {
      // this.empresaRubricas = this.empresaRubricas.filter((x, i) => i !== idx)
      rubrica.status = 'DELETE'
      this.$emit('on-change', this.empresaRubricas)
    },

    add(rubrica) {
      this.empresaRubricas = [
        ...this.empresaRubricas,
        { id: this.value.id, rubrica: rubrica.rubrica, conta: 0, status: 'INSERT' }
      ]
      this.$emit('on-change', this.empresaRubricas)
    },

    onInputChange(vl, rubrica) {
      if (rubrica.status === 'RETRIEVE') {
        rubrica.status = 'UPDATE'
      }
      rubrica.conta = vl
    },

    async getRubricas() {
      try {
        const data = await EmpresaService.getRubricas()
        this.rubricasDisponiveis = data.body.map(x => {
          return {
            rubrica: x.rubrica,
            descricao: x.nome
          }
        })
      } catch (e) {
        this.$messsages
          .error(e.message || e.data.message)
          .toast('Não foi possível buscar as rubricas.')
        console.error(e)
      }
    }
  },
  computed: {
    rubricasDescriptions() {
      let ret = {}
      for (let r of this.rubricasDisponiveis) {
        ret = Object.assign({}, ret, { [r.rubrica]: r.descricao })
      }
      return ret
    },

    rubricas() {
      return this.rubricasDisponiveis.filter(x => {
        return !this.empresaRubricas.some(z => {
          return z.rubrica === x.rubrica && z.status !== 'DELETE'
        })
      })
    }
  },

  components: {
    InputEditable
  }
}
</script>

<style lang="css"></style>
